import NewScriptLayout from "./NewScriptLayout";
import { type RootReducer } from "lib/redux/reducers";
import { createScript, editScriptAPI } from "lib/redux/scripts/action";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PROTECTED_PATHS } from "routes/pagePath";
import { errorToast } from "utils/hooks";

const isValidURL = (str: string) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // fragment locator
  return !!pattern.test(str);
};

const NewScript = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const { success } = useSelector<RootReducer, any>(
    (state: RootReducer) => state.scripts.createScript,
  );
  const editScript = useSelector<RootReducer, any>(
    (state: RootReducer) => state.scripts.editScript,
  );
  const editScriptStateAPI = useSelector<RootReducer, any>(
    (state: RootReducer) => state.scripts.editScriptStateAPI,
  );
  const [isEdit, setisEdit] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    composer: "",
    composerId: null,
    category: "All",
    document: "",
    documentName: "",
    audio: "",
    audioName: "",
    videoUrl: "",
    description: "",
    lyrics: "",
  });

  useEffect(() => {
    const url = new URL(window.location.href);
    const isEdit = url.searchParams.get("edit");
    if (isEdit && editScript) {
      setisEdit(true);
      setFormValues({
        ...formValues,
        ...editScript,
        lyrics: editScript.meta?.lyrics,
      });
    }
    // eslint-disable-next-line
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileUpload = (e) => {
    e.persist();
    const { name, files } = e.target;
    const selectedFile = files[0];

    if (selectedFile) {
      if (selectedFile.size > 10 * 1024 * 1024) {
        errorToast("File must be less than 10Mb");
        return;
      }
      if (name === "audio") {
        setFormValues({
          ...formValues,
          audioName: selectedFile.name,
          audio: selectedFile,
        });
      } else {
        if (!selectedFile.type.startsWith("image") && selectedFile.type !== "application/pdf") {
          errorToast("Please select an image or Pdf");
          return;
        }
        setFormValues({
          ...formValues,
          document: selectedFile,
          documentName: selectedFile.name,
        });
      }
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = () => {
    if (isEdit) {
      const validKeys = ["name", "composer", "composerId", "category", "description", "videoUrl"];
      const pickedValues = _.pick(formValues, validKeys);
      const formdata: any = new FormData();
      for (const [key, value] of Object.entries(pickedValues)) {
        formdata.append(key, value);
      }
      formdata.append("meta", JSON.stringify({ lyrics: formValues.lyrics }));
      formdata.append("id", editScript.id);
      dispatch(editScriptAPI(formdata));
      setIsLoading(true);
      return setTimeout(() => {
        setIsLoading(false);
        history(-1);
      }, 3000);
    }
    if (formValues.name === "") {
      errorToast("Please fill in a name");
      return;
    } else if (formValues.document === "") {
      errorToast("Please select an image or PDF");
      return;
    }
    if (formValues.videoUrl) {
      const validURL = isValidURL(formValues.videoUrl);
      if (validURL) {
        const youtubeURL = new URL(formValues.videoUrl);
        if (youtubeURL.host !== "www.youtube.com" && youtubeURL.host !== "youtu.be") {
          errorToast("Invalid Youtube URL");
          return;
        }
      } else {
        errorToast("Invalid Video URL");
        return;
      }
    }
    const formdata: any = new FormData();
    let updatedValues;
    if (formValues.composerId) {
      updatedValues = _.omit(formValues, ["composer"]);
    } else {
      updatedValues = _.omit(formValues, ["composerId"]);
    }

    for (const [key, value] of Object.entries(updatedValues)) {
      formdata.append(key, value);
    }
    formdata.append("meta", JSON.stringify({ lyrics: formValues.lyrics }));

    dispatch(createScript(formdata));
  };

  useEffect(() => {
    if (success || editScriptStateAPI.success) {
      setFormValues({
        name: "",
        composer: "",
        composerId: null,
        category: "All",
        document: "",
        documentName: "",
        audio: "",
        audioName: "",
        videoUrl: "",
        description: "",
        lyrics: "",
      });
      history(PROTECTED_PATHS.UPLOAD);
    }
  }, [history, success, editScriptStateAPI.success]);

  return (
    <NewScriptLayout
      isEdit={isEdit}
      formData={formValues}
      onChange={onChange}
      handleFileUpload={handleFileUpload}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      setFormValues={setFormValues}
      formValues={formValues}
    />
  );
};

export default NewScript;
